import React, { useEffect, useState } from 'react'
import './style.scss'
import { useParams } from 'react-router-dom'
import { slUv1Axios } from '../../../config/axios'
import SpinWithMessage from '../../../components/common/spinners/SpinWithMessage'
import { LuFileX2 } from "react-icons/lu";
import SingleButton from '../../../components/common/buttons/SingleButton'
import { FaInfoCircle } from 'react-icons/fa'
import { TbTestPipe } from 'react-icons/tb'
import { HiLocationMarker } from 'react-icons/hi'
import { FiFileText } from 'react-icons/fi'
import { MdMyLocation } from 'react-icons/md'
import { calculateGSTAmount, calculateTotalAmount } from '../../../assets/javascript/find-helpers'

const ViewEnquiryForm = ({ setPageHead }) => {
    const { e_form_srl_no } = useParams()
    const [data, setData] = useState({})
    const [error, setError] = useState('')
    const [loading, setLoading] = useState('fetch')
    const [activeMenu, setActiveMenu] = useState(1)


    useEffect(() => {

        setPageHead({ title: e_form_srl_no, desc: 'The complete view of enquiry form' })

        slUv1Axios.get(`/enquiry/e-form/single/${e_form_srl_no}`).then((response) => {
            if (response?.data) {
                setData(response?.data || {})
            } else {
                setError('No data available')
            }
            setLoading('')
        }).catch((error) => {
            setError(error.message)
            setLoading('')
        })
        // eslint-disable-next-line
    }, [])

    return (
        <div className="view-enquiry-form-page-div">
            {(loading === 'fetch' || error)
                ? <SpinWithMessage load={loading === 'fetch'} message={error} icon={<LuFileX2 />}
                    height={'400px'} />
                : <div className='border'>
                    <div className="menus">
                        <SingleButton name={'About'} classNames={activeMenu === 1 ? 'md btn-tertiary' : 'md btn-gray'}
                            stIcon={<FaInfoCircle />} onClick={() => setActiveMenu(1)} />
                        <SingleButton name={'Water test'} classNames={activeMenu === 2 ? 'md btn-tertiary' : 'md btn-gray'}
                            stIcon={<TbTestPipe />} onClick={() => setActiveMenu(2)} />
                        <SingleButton name={'Site report'} classNames={activeMenu === 3 ? 'md btn-tertiary' : 'md btn-gray'}
                            stIcon={<HiLocationMarker />} onClick={() => setActiveMenu(3)} />
                        <SingleButton name={'Solutions'} classNames={activeMenu === 4 ? 'md btn-tertiary' : 'md btn-gray'}
                            stIcon={<MdMyLocation />} onClick={() => setActiveMenu(4)} />
                        <SingleButton name={'Terms'} classNames={activeMenu === 5 ? 'md btn-tertiary' : 'md btn-gray'}
                            stIcon={<FiFileText />} onClick={() => setActiveMenu(5)} />
                    </div>

                    <div className="sections">
                        {/* Section one */}
                        {activeMenu === 1 && <div className="section-div section-one">
                            <div className="title-div">
                                <h3>About the Enquiry</h3>
                            </div>
                            <div className="section-content">
                                <table className='list-type'>
                                    <tbody>
                                        <tr>
                                            <td>Srl No</td>
                                            <td>: {data?.e_form_srl_no}</td>
                                        </tr>
                                        <tr>
                                            <td>Prospect ID</td>
                                            <td>: {data?.prospect_id}</td>
                                        </tr>
                                        <tr>
                                            <td>Salesman</td>
                                            <td>: {data?.salesman}</td>
                                        </tr>
                                        <tr>
                                            <td>Date</td>
                                            <td>: {new Date(data?.date).toDateString()}</td>
                                        </tr>
                                        <tr>
                                            <td>Enquiry For</td>
                                            <td>: {data?.enquiry_type === 'PRF' ? 'Purifier system' : data?.enquiry_type === 'VSL' ? 'Vessel system' : 'Purifier and Vessel system'}</td>
                                        </tr>
                                        <tr>
                                            <td>Q Expire Date</td>
                                            <td>: {new Date(data?.q_expire_date).toDateString()}</td>
                                        </tr>
                                        <tr>
                                            <td>Client View</td>
                                            <td>: {data?.client_comment?.map((elem) => `${elem}, `)}</td>
                                        </tr>
                                        <tr>
                                            <td>Tech Remark</td>
                                            <td>{data?.tech_remark}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>}

                        {/* Section Two */}
                        {activeMenu === 2 && <div className="section-div section-two">
                            <div className="title-div">
                                <h3>Water Test Reports</h3>
                            </div>
                            <div className="section-content">
                                {data?.test_reports?.map((test, index) => {
                                    return <div key={index} className="test-div">
                                        <h3 className='sub-title'>Test {index + 1} {data?.accepted_test_report === test?.test_id && ' : Accepted'}</h3>
                                        <table className='list-type'>
                                            <tbody>
                                                <tr>
                                                    <td>Report Type</td>
                                                    <td>: {test?.type_of} {test?.type_of === 'Lab' && `(${test?.lab_name})`}</td>
                                                </tr>
                                                <tr>
                                                    <td>Source</td>
                                                    <td>: {test?.source}</td>
                                                </tr>
                                                <tr>
                                                    <td>TDS</td>
                                                    <td>: {test?.tds} mg/L</td>
                                                </tr>
                                                <tr>
                                                    <td>PH</td>
                                                    <td>: {test?.ph} mg/L</td>
                                                </tr>
                                                <tr>
                                                    <td>Color (Motor)</td>
                                                    <td>: {test?.color_from_motor}</td>
                                                </tr>
                                                <tr>
                                                    <td>Color (Tank)</td>
                                                    <td>: {test?.color_from_tank}</td>
                                                </tr>
                                                <tr>
                                                    <td>Odor / Smell</td>
                                                    <td>: {test?.odor}</td>
                                                </tr>
                                                <tr>
                                                    <td>Iron (Fe)</td>
                                                    <td>: {Number(test?.i_ferrous) + Number(test?.i_ferric)}</td>
                                                </tr>
                                                {test?.magnesium && <tr>
                                                    <td>Magnesium</td>
                                                    <td>: {test?.magnesium}</td>
                                                </tr>}
                                                <tr>
                                                    <td>Calcium</td>
                                                    <td>: {test?.calcium}</td>
                                                </tr>
                                                <tr>
                                                    <td>Findings</td>
                                                    <td>{test?.findings?.map((arr) => <span>- {arr[2]}<br></br></span>)}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                })}

                            </div>
                        </div>}

                        {/* site reports */}
                        {activeMenu === 3 && <div className="section-div section-two">
                            <div className="title-div">
                                <h3>Site Reports</h3>
                            </div>
                            <div className="section-content">
                                <div className="test-div">
                                    <table className='list-type'>
                                        <tbody>
                                            <tr>
                                                <td>Site</td>
                                                <td>: {data?.work_site}</td>
                                            </tr>
                                            <tr>
                                                <td>Site Category</td>
                                                <td>: {data?.work_site_category}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                {data?.purifier_site_report?.usage &&
                                    <div className="test-div">
                                        <h3 className='sub-title'>Purifier Filter</h3>
                                        <table className='list-type'>
                                            <tbody>
                                                <tr>
                                                    <td>Usage</td>
                                                    <td>: {data?.purifier_site_report?.usage} Litter/Day</td>
                                                </tr>
                                                <tr>
                                                    <td>Water Point</td>
                                                    <td>: {data?.purifier_site_report?.wt_point} </td>
                                                </tr>
                                                {data?.purifier_site_report?.wt_point !== 'No' &&
                                                    <tr>
                                                        <td>Water point distance</td>
                                                        <td>: {data?.purifier_site_report?.wt_point_dst} Meter</td>
                                                    </tr>}
                                                <tr>
                                                    <td>Installation Mode</td>
                                                    <td>: {data?.purifier_site_report?.i_mode}</td>
                                                </tr>
                                                <tr>
                                                    <td>Cupboard Distance</td>
                                                    <td>: {data?.purifier_site_report?.cb_dst}cm</td>
                                                </tr>
                                                <tr>
                                                    <td>Cupboard (W x H)</td>
                                                    <td>: {data?.purifier_site_report?.cb_width || 0}cm x {data?.purifier_site_report?.cb_hight || 0}cm </td>
                                                </tr>
                                                <tr>
                                                    <td>Reject Water to</td>
                                                    <td>: {data?.purifier_site_report?.reject_wt_to}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>}

                                {data?.vessel_site_report?.usage &&
                                    <div className="test-div">
                                        <h3 className='sub-title'>Vessel Filter</h3>
                                        <table className='list-type'>
                                            <tbody>
                                                <tr>
                                                    <td>No of Floors</td>
                                                    <td>: {data?.vessel_site_report?.n_o_floor}</td>
                                                </tr>
                                                <tr>
                                                    <td>Tank Storage Capacity</td>
                                                    <td>: {data?.vessel_site_report?.storage_capacity} Litter</td>
                                                </tr>
                                                <tr>
                                                    <td>Usage</td>
                                                    <td>: {data?.vessel_site_report?.usage} Litter/Day</td>
                                                </tr>
                                                <tr>
                                                    <td>Bathroom in Top</td>
                                                    <td>: {data?.vessel_site_report?.bath_in_top}</td>
                                                </tr>
                                                <tr>
                                                    <td>Solar Water Filter</td>
                                                    <td>: {data?.vessel_site_report?.solar_wf}</td>
                                                </tr>
                                                {data?.vessel_site_report?.solar_wf === 'Yes' &&
                                                    <tr>
                                                        <td>Solar WF Position</td>
                                                        <td>: {data?.vessel_site_report?.solar_wf_pstn} Feet</td>
                                                    </tr>}
                                                <tr>
                                                    <td>Tank Position</td>
                                                    <td>: {data?.vessel_site_report?.tank_pstn} Feet</td>
                                                </tr>
                                                <tr>
                                                    <td>T Hight</td>
                                                    <td>: {data?.vessel_site_report?.t_ht} Feet</td>
                                                </tr>
                                                <tr>
                                                    <td>Tank out connection</td>
                                                    <td>: {data?.vessel_site_report?.tank_out_connection}</td>
                                                </tr>
                                                <tr>
                                                    <td>Pipe Bend in Out</td>
                                                    <td>: {data?.vessel_site_report?.out_bend}</td>
                                                </tr>
                                                <tr>
                                                    <td>Inlet</td>
                                                    <td>: {data?.vessel_site_report?.inlet}mm</td>
                                                </tr>
                                                <tr>
                                                    <td>Outlet</td>
                                                    <td>: {data?.vessel_site_report?.outlet}mm</td>
                                                </tr>
                                                <tr>
                                                    <td>Pipe category</td>
                                                    <td>: {data?.vessel_site_report?.pipe_type}</td>
                                                </tr>
                                                <tr>
                                                    <td>Motor Details</td>
                                                    <td>: {data?.vessel_site_report?.about_motor}</td>
                                                </tr>
                                                <tr>
                                                    <td>Tank filling time</td>
                                                    <td>: {data?.vessel_site_report?.tank_fill_tm} Minutes</td>
                                                </tr>
                                                <tr>
                                                    <td>Installation position</td>
                                                    <td>: {data?.vessel_site_report?.i_position}</td>
                                                </tr>
                                                <tr>
                                                    <td>Basement</td>
                                                    <td>: {data?.vessel_site_report?.basement}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>}
                            </div>
                        </div>}

                        {/* Solutions */}
                        {activeMenu === 4 && <div className="section-div section-two">
                            <div className="title-div">
                                <h3>Problem Solutions</h3>
                            </div>
                            <div className="section-content">
                                {data?.preferred_solutions?.[0] &&
                                    <div className="test-div">
                                        <h3 className='sub-title'>Preferred Solutions</h3>
                                        <ProductTableList tableData={data?.preferred_solutions} billData={data?.bill_data} />
                                    </div>}
                                {data?.customer_selected?.[0] &&
                                    <div className="test-div">
                                        <h3 className='sub-title'>Customer Selected Solutions</h3>
                                        <ProductTableList tableData={data?.customer_selected} billData={data?.bill_data} />
                                    </div>}
                                {data?.purifier_components?.[0] &&
                                    <div className="test-div">
                                        <h3 className='sub-title'>Purifier components</h3>
                                        <ElementTableList tableData={data?.purifier_components} />
                                    </div>}
                                {data?.vessel_components?.[0] &&
                                    <div className="test-div">
                                        <h3 className='sub-title'>Vessel components</h3>
                                        <ElementTableList tableData={data?.vessel_components} />
                                    </div>}
                                {data?.vessel_materials?.[0] &&
                                    <div className="test-div">
                                        <h3 className='sub-title'>Vessel materials</h3>
                                        <ElementTableList tableData={data?.vessel_materials} />
                                    </div>}
                            </div>
                        </div>}

                        {/* Terms */}
                        {activeMenu === 5 && <div className="section-div section-two">
                            <div className="title-div">
                                <h3>Terms and Conditions</h3>
                            </div>
                            <div className="section-content">
                                <div className="test-div">
                                    <h3 className='sub-title'>Warranty</h3>
                                    <table className='list-type'>
                                        <tbody>
                                            {data?.warranty?.purifier && <tr>
                                                <td>Purifier</td>
                                                <td>: {data?.warranty?.purifier}</td>
                                            </tr>}
                                            {data?.warranty?.vessel && <tr>
                                                <td>Vessel</td>
                                                <td>: {data?.warranty?.vessel}</td>
                                            </tr>}
                                        </tbody>
                                    </table>
                                </div>

                                <div className="test-div">
                                    <h3 className='sub-title'>Terms and Conditions</h3>
                                    <ul>
                                        {data?.terms_conditions?.map((arr) => {
                                            return <li style={{ fontSize: '14px', lineHeight: '22px' }}>{arr?.[2]}</li>
                                        })}
                                    </ul>
                                </div>
                            </div>
                        </div>}
                    </div>
                </div>}
        </div>
    )
}

export default ViewEnquiryForm

function ProductTableList({ tableData, billData }) {
    return <table className='product-table'>
        <tbody>
            {tableData?.map((obj, index) => {
                return <tr key={obj?.product_id}>
                    <td>{obj?.product_name} {obj?.product_category || ''}</td>
                    <td style={{ whiteSpace: 'nowrap' }}>₹ {obj?.rate}</td>
                    <td>{obj?.qty}</td>
                    <td style={{ whiteSpace: 'nowrap' }}>₹ {Number(obj?.rate) * Number(obj?.qty)}</td>
                </tr>
            })}
            {!billData?.gst_include && <tr>
                <td>Discount</td>
                <td></td>
                <td></td>
                <td>₹ <input name='discount' type='number' value={billData?.discount} placeholder='0' min={1} /></td>
            </tr>}
            {billData?.gst_include && <tr>
                <td>GST (18%)</td>
                <td></td>
                <td></td>
                <td>₹ {calculateGSTAmount(tableData)}</td>
            </tr>}
            <tr className='total-amount'>
                <td>Total Amount</td>
                <td></td>
                <td></td>
                <td>₹ {calculateTotalAmount(tableData || [], billData?.discount || 0, billData?.gst_include)}</td>
            </tr>
        </tbody>
    </table>
}


function ElementTableList({ tableData }) {
    return <table className='product-table'>
        <tbody>
            {tableData?.map((obj) => {
                return <tr key={obj?.item + obj?.brand}>
                    <td>{obj?.item}</td>
                    <td>{obj?.brand}</td>
                </tr>
            })}
        </tbody>
    </table>
}